export default __webpack_public_path__ + "static/media/dotted-disk.frag.118953b3.glsl";